var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNccaModule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173475",
    transform: "translate(18253 6217)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 145019",
    width: 14,
    height: 16,
    rx: 1,
    transform: "translate(-18253 -6217)",
    style: {
      fill: "#3b82f4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173401"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21045",
    d: "m108.708 165.473-2.728.008a.318.318 0 0 1-.32-.317l-.006-2.238a.318.318 0 0 1 .318-.319l2.728-.008a.318.318 0 0 1 .32.317l.006 2.238a.318.318 0 0 1-.318.319",
    transform: "translate(-18356.346 -6378.071)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21046",
    d: "m535.013 201.1-5.251.015a.339.339 0 1 1 0-.678l5.251-.015a.339.339 0 1 1 0 .678",
    transform: "translate(-18775.922 -6415.516)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21047",
    d: "m535.418 344.173-5.251.015a.339.339 0 1 1 0-.678l5.251-.015a.339.339 0 1 1 0 .678",
    transform: "translate(-18776.322 -6557.182)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21048",
    d: "m118.817 555.588-9.326.026a.342.342 0 1 1 0-.678l9.326-.026a.342.342 0 1 1 0 .678",
    transform: "translate(-18359.762 -6766.511)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21049",
    d: "m117.043 727.218-9.44.027a.339.339 0 1 1 0-.678l9.44-.026a.339.339 0 1 1 0 .678",
    transform: "translate(-18357.937 -6936.448)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21050",
    d: "m118.956 1403.992-9.44.027a.339.339 0 1 1 0-.678l9.44-.027a.339.339 0 1 1 0 .678",
    transform: "translate(-18359.832 -7606.547)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21051",
    d: "m118.885 1232.366-9.343.026a.342.342 0 1 1 0-.678l9.343-.027a.342.342 0 1 1 0 .678",
    transform: "translate(-18359.812 -7436.614)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21052",
    d: "M124.614 898.807h-.463a.127.127 0 1 1 0-.254h.463v.254zm-.9 0H123.228a.127.127 0 1 1 0-.255h.463a.127.127 0 0 1 .023.252m1.164-.33h-.023a.127.127 0 0 1-.128-.126v-.462a.127.127 0 0 1 .255 0v.462a.127.127 0 0 1-.1.125m-2.09.333h-.492a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.253m-.926 0H121.374a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-.926 0H120.449a.127.127 0 1 1 0-.255h.463a.127.127 0 0 1 .023.252m-.926 0H119.524a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-.926 0H118.599a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-.926 0H117.673a.127.127 0 1 1 0-.255h.463a.127.127 0 0 1 .023.252m6.718-1.269h-.023a.127.127 0 0 1-.128-.127v-.462a.127.127 0 0 1 .255 0v.462a.127.127 0 0 1-.1.126m-7.644 1.272H116.752a.127.127 0 1 1 0-.255h.463a.127.127 0 0 1 .023.252m-.926 0H115.827a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.253m-.926 0a.131.131 0 0 1-.031 0 .365.365 0 0 1-.337-.3.37.37 0 0 1-.006-.064v-.1a.127.127 0 0 1 .255 0v.1a.114.114 0 0 0 0 .02.111.111 0 0 0 .1.091.127.127 0 0 1 .015.252m9.271-2.079a.125.125 0 0 1-.031 0h-.454a.127.127 0 1 1 0-.254h.472a.127.127 0 0 1 .015.252m-.926 0H123.245a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-.926 0H122.32a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-7.643 1.271h-.023a.127.127 0 0 1-.14-.076v-.462a.127.127 0 0 1 .255 0v.462a.128.128 0 0 1-.1.126m6.717-1.269H121.387a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-.926 0H120.462a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-.926 0H119.536a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-.926 0h-.496a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-.926 0H117.674a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-.926 0H116.749a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252m-2.09.332h-.023a.127.127 0 0 1-.128-.127v-.088a.365.365 0 0 1 .3-.36.372.372 0 0 1 .064-.006.127.127 0 1 1 0 .254.112.112 0 0 0-.111.111v.088a.127.127 0 0 1-.1.126m1.164-.329H115.826a.127.127 0 1 1 0-.254h.463a.127.127 0 0 1 .023.252",
    transform: "translate(-18365.598 -7104.732)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21053",
    d: "m37.416 970.558-9.327-.019a.216.216 0 0 0-.217.216v1.9a.216.216 0 0 0 .216.217l9.327.019a.216.216 0 0 0 .217-.216v-1.9a.216.216 0 0 0-.216-.216",
    transform: "translate(-18279.33 -7178.041)",
    style: {
      fill: "#2162d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6688",
    transform: "translate(-18251.461 -6207.502)",
    style: {
      fill: "none"
    },
    d: "M0 0h9.763v2.35H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21054",
    d: "m53.132 939.12-9.327-.019a.216.216 0 0 1-.216-.216v-1.9a.216.216 0 0 1 .217-.216l9.327.019a.216.216 0 0 1 .216.217v1.9a.216.216 0 0 1-.217.216",
    transform: "translate(-18294.894 -7144.605)",
    style: {
      fill: "#f4b545"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21055",
    d: "M73.06 965.4h-1.62a.171.171 0 0 1-.171-.171v-1.461a.171.171 0 0 1 .172-.17h1.62a.171.171 0 0 1 .171.171v1.46a.171.171 0 0 1-.172.171",
    transform: "translate(-18322.301 -7171.163)",
    style: {
      fill: "#ffdca4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21056",
    d: "m106.838 991.149.017-.073h.175l-.1.473a.38.38 0 0 0-.01.059.035.035 0 0 0 .007.024.025.025 0 0 0 .018.009.164.164 0 0 0 .093-.046.4.4 0 0 0 .1-.126.385.385 0 0 0 .014-.324.347.347 0 0 0-.086-.122.407.407 0 0 0-.14-.081.576.576 0 0 0-.189-.03.663.663 0 0 0-.2.027.5.5 0 0 0-.159.079.456.456 0 0 0-.115.129.56.56 0 0 0-.062.149.662.662 0 0 0-.022.167.471.471 0 0 0 .044.208.421.421 0 0 0 .131.159.543.543 0 0 0 .208.092.882.882 0 0 0 .277.012.662.662 0 0 0 .208-.054.409.409 0 0 0 .145-.114h.141a.467.467 0 0 1-.09.126.5.5 0 0 1-.13.092.661.661 0 0 1-.166.057.966.966 0 0 1-.2.019.943.943 0 0 1-.293-.045.6.6 0 0 1-.219-.124.522.522 0 0 1-.134-.192.642.642 0 0 1-.044-.246.726.726 0 0 1 .048-.262.6.6 0 0 1 .353-.351.751.751 0 0 1 .281-.049.692.692 0 0 1 .23.038.509.509 0 0 1 .179.106.456.456 0 0 1 .113.163.531.531 0 0 1 .038.208.5.5 0 0 1-.125.325.44.44 0 0 1-.14.106.383.383 0 0 1-.173.038.158.158 0 0 1-.083-.019.089.089 0 0 1-.039-.058.258.258 0 0 1-.133.071.25.25 0 0 1-.145-.015.241.241 0 0 1-.113-.1.306.306 0 0 1-.042-.168.5.5 0 0 1 .046-.2.421.421 0 0 1 .128-.164.3.3 0 0 1 .187-.063.19.19 0 0 1 .174.09m-.364.34a.194.194 0 0 0 .032.122.1.1 0 0 0 .086.043.148.148 0 0 0 .11-.049.323.323 0 0 0 .072-.125.473.473 0 0 0 .025-.146.223.223 0 0 0-.008-.063.154.154 0 0 0-.024-.05.11.11 0 0 0-.039-.032.118.118 0 0 0-.052-.011.148.148 0 0 0-.105.044.3.3 0 0 0-.072.117.453.453 0 0 0-.026.149",
    transform: "translate(-18356.74 -7198.092)",
    style: {
      fill: "#e09f36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21057",
    d: "m302.656 978.416-3.092-.006a.164.164 0 1 1 0-.328l3.092.006a.164.164 0 1 1 0 .328",
    transform: "translate(-18548.176 -7185.509)",
    style: {
      fill: "#e09f36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21058",
    d: "m306.021 1039.141-6.582-.013a.164.164 0 1 1 0-.328l6.582.013a.164.164 0 1 1 0 .328",
    transform: "translate(-18548.053 -7245.628)",
    style: {
      fill: "#ffdca4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21059",
    d: "m305.9 1099.847-6.582-.014a.164.164 0 1 1 0-.328l6.582.013a.164.164 0 1 1 0 .328",
    transform: "translate(-18547.93 -7305.736)",
    style: {
      fill: "#ffdca4"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNccaModule);
export default __webpack_public_path__ + "static/media/NCCA-Module.813331953f1d6ef1e2f9c9cab061fd0a.svg";
export { ForwardRef as ReactComponent };